import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { Text, TextType } from 'ui-components/components/text';
import Global from '../../../../../store/global-selectors';
import { CurrencyService } from '../../../../../services/currency-service';
import { USD } from '../../../../../constants/currency-codes';
import style from './style.module.less';

export const ZeroCostLabel = ({ className = '' }) => {
  const intl = useIntl();
  const sellerDefaultCurrencyCode = useSelector(Global.selectSellerDefaultCurrency);
  const { symbol } = CurrencyService.getSymbolFromCode(sellerDefaultCurrencyCode, USD, intl.locale);

  return <Text className={classnames(style['zero-cost'], className)} textType={TextType.Label} value={`${symbol || '$'}--.--`} />;
};

ZeroCostLabel.propTypes = {
  className: PropTypes.string,
};
